module.exports = __webpack_public_path__ + "img/member3.9dbe5ab3.png";